import React, { useState } from "react";

import SectionTitle from "@app/components/3_modules/sections/SectionTitle";
import ButtonSecondary from "@app/components/1_elements/ButtonSecondary";

import { ChartColumn } from "lucide-react";
import { apiCall } from '@app/utils/apiCall';
import { useAuth } from '@app/contexts/AuthContext';
import { useNavigate } from "react-router-dom";
import { FileQuestionMark, Clock4 } from "lucide-react";

import Badge from "@app/components/1_elements/Badge";
import CustomerDelete from "@app/components/2_widgets/customers/CustomerDelete";
import { useTranslation } from "react-i18next";

export default function SectionDossierEligibles() {
    const [loaded, setLoaded] = useState(false);
    const [dossiers, setDossiers] = useState([]);

    const auth = useAuth();
    const navigate = useNavigate();

    const { t } = useTranslation();
        
    if (!loaded) {
        apiCall ({
            method: "get",
            path: `/api/v1/dossiers?all_eligibiles=true`,
            auth: auth,
            onSuccess: (response) => {
                setDossiers(response.data.dossiers);
                setLoaded(true);
            }
        });
    }

    function goToDossier(dossier) {
        navigate(`/customers/${dossier.customer.id}`)
    }

    function getTabName(dossier) {
        if (dossier.tax_year)
            return (`Bilan ${dossier.tax_year}`)
        else
            return "Nouveau bilan"
    }

    function displayRow(dossier, index) {
        const customer = dossier.customer;

        return (
           <tr key={`${index}`}>
                <td key="1" onClick={() => goToDossier(dossier)}>
                    <strong>{customer.trade_name || customer.company_name}</strong>
                    <br/>
                    <span className="light-text">{customer.siren}</span>
                </td>
                <td key="2" onClick={() => goToDossier(dossier)}>
                    <span className="light-text">{getTabName(dossier)}</span>
                    <br/>
                    <Badge label={t(`dossier.status.${dossier.status}`)} classProp={`badge-${dossier.status}`} icon={<Clock4 />}/>                    
                </td>
                <td onClick={() => goToDossier(dossier)}>
                    <Badge label="À envoyer" classProp="badge-to_send" icon={<Clock4 />}/>
                </td>
                <td>
                    <CustomerDelete customer={customer} reload={() => setLoaded(false)}/>
                </td>
            </tr>             
        )
    }

    return (
        <div>
            <section className="page-section">
                <SectionTitle
                    icon={<ChartColumn />}
                    title="Dossiers"
                    subtitle={`${dossiers.length} dossiers`}
                />
                <div className="custom-table-component">                
                    <table className="custom-table">
                        <thead>
                            <tr>
                                <th key="1">
                                    Entreprise
                                </th>
                                <th key="2">
                                    Bilan
                                </th>
                                <th key="3">
                                    Devis
                                </th>
                                <th key="4">                                    
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {dossiers.map(displayRow)}
                        </tbody>
                    </table>
                </div>                                
            </section>
        </div>
    )
}